import { render, staticRenderFns } from "./NoticeViewForm.vue?vue&type=template&id=42885f7d"
import script from "./NoticeViewForm.vue?vue&type=script&lang=js"
export * from "./NoticeViewForm.vue?vue&type=script&lang=js"
import style0 from "./NoticeViewForm.vue?vue&type=style&index=0&id=42885f7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports